/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileGroupItemDto } from './FileGroupItemDto';
import {
    FileGroupItemDtoFromJSON,
    FileGroupItemDtoFromJSONTyped,
    FileGroupItemDtoToJSON,
    FileGroupItemDtoToJSONTyped,
} from './FileGroupItemDto';

/**
 * 
 * @export
 * @interface GetFileGroupResponse
 */
export interface GetFileGroupResponse {
    /**
     * 
     * @type {Array<FileGroupItemDto>}
     * @memberof GetFileGroupResponse
     */
    items: Array<FileGroupItemDto>;
}

/**
 * Check if a given object implements the GetFileGroupResponse interface.
 */
export function instanceOfGetFileGroupResponse(value: object): value is GetFileGroupResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetFileGroupResponseFromJSON(json: any): GetFileGroupResponse {
    return GetFileGroupResponseFromJSONTyped(json, false);
}

export function GetFileGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFileGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(FileGroupItemDtoFromJSON)),
    };
}

export function GetFileGroupResponseToJSON(json: any): GetFileGroupResponse {
    return GetFileGroupResponseToJSONTyped(json, false);
}

export function GetFileGroupResponseToJSONTyped(value?: GetFileGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(FileGroupItemDtoToJSON)),
    };
}

